var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm.showButton ? _c('OmniButton', _vm._b({
    attrs: {
      "variant": _vm.variant,
      "disabled": _vm.isPackingSlipRequested,
      "title": _vm.title
    },
    on: {
      "click": _vm.printPackingSlip
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [!_vm.isPackingSlipRequested ? _c('font-awesome-icon', {
          class: _vm.size,
          attrs: {
            "icon": "print"
          }
        }) : _c('font-awesome-icon', _vm._b({
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        }, 'font-awesome-icon', [_vm.$attrs], false))];
      },
      proxy: true
    }], null, false, 2614898845)
  }, 'OmniButton', _vm.$props, false), [_vm._t("default", function () {
    return [!_vm.isPackingSlipRequested ? _c('span', _vm._b({}, 'span', [_vm.$attrs], false), [_vm._v(_vm._s(_vm.title))]) : _vm._e()];
  })], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }